<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button color="medium" (click)="cancel()">Cancel</ion-button>
    </ion-buttons>
    <ion-title>Send Document</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="send()" [disabled]="!form.valid" [strong]="true">Send</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content color="light">
  <form [formGroup]="form" (ngSubmit)="send()">
    <div class="tw:m-4 tw:text-xs">
      <ion-note color="medium">Send the document for this transaction to the email address specified below.</ion-note>
    </div>
    <ion-list [inset]="true" class="no-last-line">
      <ion-item>
        <ion-input
          redErrorMessage
          labelPlacement="stacked"
          placeholder="email@example.com"
          inputmode="email"
          [required]="true"
          type="email"
          formControlName="email"
        >
          <div slot="label">Email: <ion-text color="danger">*</ion-text></div>
        </ion-input>
      </ion-item>
      <ion-item>
        <ion-textarea
          redErrorMessage
          labelPlacement="stacked"
          placeholder="Transaction document"
          inputmode="text"
          [autoGrow]="true"
          [required]="true"
          type="text"
          formControlName="subject"
        >
          <div slot="label">Subject: <ion-text color="danger">*</ion-text></div>
        </ion-textarea>
      </ion-item>
      <ion-item>
        <ion-textarea
          labelPlacement="stacked"
          placeholder="Here you can type some message to be sent in the email."
          inputmode="text"
          type="text"
          formControlName="message"
          [rows]="4"
          [autoGrow]="true"
        >
          <div slot="label">Message:</div>
        </ion-textarea>
      </ion-item>
    </ion-list>
  </form>
</ion-content>
